const areabumpdata = [
    {
      "id": "JavaScript",
      "data": [
        {
          "x": 2000,
          "y": 25
        },
        {
          "x": 2001,
          "y": 30
        },
        {
          "x": 2002,
          "y": 26
        },
        {
          "x": 2003,
          "y": 17
        },
        {
          "x": 2004,
          "y": 25
        },
        {
          "x": 2005,
          "y": 22
        }
      ]
    },
    {
      "id": "ReasonML",
      "data": [
        {
          "x": 2000,
          "y": 17
        },
        {
          "x": 2001,
          "y": 13
        },
        {
          "x": 2002,
          "y": 25
        },
        {
          "x": 2003,
          "y": 23
        },
        {
          "x": 2004,
          "y": 18
        },
        {
          "x": 2005,
          "y": 15
        }
      ]
    },
    {
      "id": "TypeScript",
      "data": [
        {
          "x": 2000,
          "y": 20
        },
        {
          "x": 2001,
          "y": 27
        },
        {
          "x": 2002,
          "y": 29
        },
        {
          "x": 2003,
          "y": 11
        },
        {
          "x": 2004,
          "y": 29
        },
        {
          "x": 2005,
          "y": 22
        }
      ]
    },
    {
      "id": "Elm",
      "data": [
        {
          "x": 2000,
          "y": 22
        },
        {
          "x": 2001,
          "y": 29
        },
        {
          "x": 2002,
          "y": 27
        },
        {
          "x": 2003,
          "y": 23
        },
        {
          "x": 2004,
          "y": 17
        },
        {
          "x": 2005,
          "y": 18
        }
      ]
    },
    {
      "id": "CoffeeScript",
      "data": [
        {
          "x": 2000,
          "y": 20
        },
        {
          "x": 2001,
          "y": 11
        },
        {
          "x": 2002,
          "y": 10
        },
        {
          "x": 2003,
          "y": 21
        },
        {
          "x": 2004,
          "y": 13
        },
        {
          "x": 2005,
          "y": 15
        }
      ]
    }
  ]
export default areabumpdata;